import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../config/config";


import img1 from '../Images/iit rank (1).webp'
import img2 from '../Images/iit rank (4).webp'
import img3 from '../Images/iit rank (3).webp'
import img4 from '../Images/iit rank (2).webp'
import img5 from '../Images/iit rank (1).webp'
import img6 from '../Images/iit rank (1).webp'

import call_icon from '../Images/graphicon.webp'
import call_icon2 from '../Images/graphicon2.webp'



const tabcardData = [
    { id: 1, courses: ["Indiatoday", "The Week", "NIRF", "Outlook", "IIRF",] },
    { id: 2, courses: ["TOI", "NIRF", "NIRF Innovation"] },
    { id: 3, courses: ["THE", "QS",] },

];



const Collegeranking = () => {
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_collegespage`);
                const fetchedData = response.data.collegePages || [];

                // Sort by rank ascending
                const sortedData = [...fetchedData].sort((a, b) => a.rank);

                // Show ALL colleges (removed slice limit as requested)
                setTableData(sortedData);
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchCollegeData();
    }, []);

    const staticImages = [img1, img2, img3, img4, img5, img6];

    return (
        <div className="bg-white">
            {/* Call to Action - Chances */}
            <div className="container mx-auto px-4 mt-8">
                <div className="bg-orange-50 border border-orange-100 rounded-3xl p-8 relative overflow-hidden flex flex-col md:flex-row items-center justify-between">
                    <div className="relative z-10 text-center md:text-left mb-6 md:mb-0">
                        <h4 className="text-2xl font-bold text-gray-800 mb-2">Know your chances of Admission</h4>
                        <p className="text-gray-600">Check your eligibility for top colleges based on your rank.</p>
                        <Link to="/contact" className="inline-block mt-4 bg-brand-orange text-white font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl hover:bg-orange-700 transition">
                            Start Now
                        </Link>
                    </div>
                    <div className="w-40 md:w-56 relative z-10">
                        <img src={call_icon} alt="Graph Icon" className="w-full object-contain drop-shadow-md" />
                    </div>
                </div>
            </div>

            {/* College Ranking List */}
            <div className="container mx-auto px-4 mt-16 mb-16">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-800">College Ranking 2025</h2>
                    <div className="w-24 h-1 bg-brand-orange mx-auto mt-4 rounded-full"></div>
                </div>

                {/* Ranking Tabs */}
                <div className="flex flex-wrap justify-center gap-4 mb-10">
                    {tabcardData.flatMap(card => card.courses).map((course, index) => (
                        <span key={index} className="px-5 py-2 bg-white border border-gray-200 rounded-full text-xs font-bold text-gray-600 uppercase tracking-wider hover:bg-brand-orange hover:text-white hover:border-brand-orange transition-all cursor-pointer shadow-sm">
                            {course}
                        </span>
                    ))}
                </div>

                {/* College List Table */}
                <div className="bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden">
                    <div className="grid grid-cols-12 gap-4 p-5 border-b border-gray-100 bg-gray-50 text-xs font-bold text-gray-500 uppercase tracking-widest hidden md:grid">
                        <div className="col-span-8">College</div>
                        <div className="col-span-2 text-center">Ranking</div>
                        <div className="col-span-2 text-center">Streams</div>
                    </div>

                    {tableData.length > 0 ? (
                        tableData.map((college, index) => (
                            <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-4 p-5 border-b last:border-0 border-gray-50 hover:bg-blue-50/50 transition items-center">
                                {/* College Name & Logo */}
                                <div className="col-span-8 flex items-center gap-4">
                                    <div className="w-12 h-12 flex-shrink-0 bg-white rounded-lg border border-gray-100 flex items-center justify-center p-1">
                                        <img
                                            src={staticImages[index % staticImages.length]}
                                            className="w-full h-full object-contain"
                                            alt="college logo"
                                        />
                                    </div>
                                    <Link to={`/college/${college._id}`} className="font-bold text-gray-800 hover:text-brand-orange transition text-sm md:text-base">
                                        {college.collegeName || "College Name"}
                                    </Link>
                                </div>

                                {/* Ranking */}
                                <div className="col-span-2 text-center">
                                    <span className="inline-block px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-xs font-bold border border-blue-100">
                                        #{index + 1}
                                    </span>
                                </div>

                                {/* Stream */}
                                <div className="col-span-2 text-center text-sm text-gray-500 font-medium">
                                    Overall
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-12 text-gray-500">
                            No rankings available
                        </div>
                    )}
                </div>
            </div>

            {/* Subscribe Call to Action */}
            <div className="container mx-auto px-4 mb-20">
                <div className="bg-blue-50 border border-blue-100 rounded-3xl p-8 flex flex-col md:flex-row items-center justify-between overflow-hidden">
                    <div className="text-center md:text-left mb-6 md:mb-0 relative z-10">
                        <h4 className="text-2xl font-bold text-gray-800 mb-2">Subscribe For Regular Alerts</h4>
                        <Link to="/contact" className="inline-block mt-4 bg-brand-orange text-white font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl hover:bg-orange-700 transition">
                            Subscribe Now
                        </Link>
                    </div>
                    <div className="w-48 md:w-64 relative z-10">
                        <img src={call_icon2} alt="Subscribe Icon" className="w-full object-contain drop-shadow-md" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Collegeranking
